/**支付状态流转
待支付(0)
 → 支付中(1) → 已支付(2)
              ↓
          支付失败(3) → 重新支付
              ↓
          已取消(2) → 重新购买（超时）
**/
import { http } from "../base"
import { getCartItems } from '@/api/tenant/cart'


export async function createOrder(orderData) {
  console.log(orderData);
  try {
    const response = await http.post(
      '/aics/order/create',
      orderData
    );
    return response.data;
  } catch (error) {
    console.error("创建订单失败:", error);
    throw error;
  }
}

export async function getOrderDetail(orderNo) {
  try {
    const response = await http.get(
      `/aics/order/detail/${orderNo}`
    );
    return response.data;
  } catch (error) {
    console.error("查询订单详情失败:", error);
    throw error;
  }
}

// 添加取消订单接口
export async function cancelOrder(orderNo) {
  try {
    const response = await http.post(
      `/aics/order/cancel/${orderNo}`
    );
    return response.data;
  } catch (error) {
    console.error("取消订单失败:", error);
    throw error;
  }
}

// 更新getOrdersByTenant函数，支持参数
export async function getOrdersByTenant(params = {}) {
  console.log("getOrdersByTenant", params);
  try {
    const response = await http.get(
      '/aics/order/list',
      { params }
    );
    return response.data;
  } catch (error) {
    console.error("查询订单列表失败:", error);
    throw error;
  }
}

/**
 * 预创建订单接口（计算价格，不实际下单）
 * @param {Array|Object} cartData - 购物车数据，可以是：
 *  1. 购物车项数组
 *  2. 包含items字段的对象
 *  3. 为空时自动获取当前购物车
 * @returns {Promise} 订单价格计算结果
 */
export async function preCreateOrder(cartData = null) {
    
      console.log(cartData);
      try{
      // 1. 准备请求数据
      let requestData = {}
      //if (cartData === null) {
        // 情况1：无参数，自动获取当前购物车
        console.log("情况1：无参数，自动获取当前购物车")
        const cartResponse = await getCartItems()
            console.log("getCartItems()",cartResponse)
        const cartItems = cartResponse.data.data || []
        requestData.items = formatCartItems(cartItems)
        console.log("requestData.items",requestData.items)
     // } else if (Array.isArray(cartData)) {
        
        console.log("requestData",requestData);
        // 调用统一接口
          const response = await http.post(
              '/aics/order/precreate',
              requestData,
              {
                  headers: {
                      'Content-Type': 'application/json',
                      'X-Request-From': 'checkout-page'
                  },
                  timeout: 10000
              }
          );    
  
      // 3. 验证响应格式
      console.log("调用/aics/order/precreate'接口的结果",response)
      if (!response.data || response.data.code !== 200) {
        throw new Error(response.data.message || '预创建订单失败')
      }
      
    // 4. 处理响应数据
        const result = response.data.data || response.data;
        console.log("预创建订单 响应数据", result);
        
        // 增强的字段验证，支持多种命名格式
        const hasValidData = validateOrderResult(result);
        
        if (!hasValidData) {
            console.warn('预创建订单响应数据不完整:', result);
            throw new Error('服务器返回数据异常');
        }
        
        // 返回统一格式的结果
        return response;   
        
    } catch (error) {
       console.error("preCreateOrder error:", error)
    }
}


/**
 * 格式化购物车项为后端需要的格式
 * @param {Array} cartItems - 购物车项数组
 * @returns {Array} 格式化后的数组
 */
function formatCartItems(cartItems) {
  if (!Array.isArray(cartItems)) {
    return []
  }
  
  return cartItems.map(item => ({
    itemId: item.itemId || item.id,
    itemType: item.itemType || 1, // 默认套餐
    quantity: item.quantity || 1,
    // 可选字段，用于调试
    itemName: item.itemName,
    unitPrice: item.unitPrice
  })).filter(item => item.itemId && item.itemType && item.quantity > 0)
}

/**
 * 缓存预创建订单结果
 
function cachePreOrderResult(result) {
  try {
    const cacheData = {
      ...result,
      cachedAt: Date.now(),
      expiresAt: Date.now() + (result.priceValidSeconds || 300) * 1000
    }
    
    localStorage.setItem('preOrderCache', JSON.stringify(cacheData))
    sessionStorage.setItem('latestPreOrder', JSON.stringify(result))
    
  } catch (error) {
    console.warn('缓存预创建订单失败:', error)
  }
}*/

/**
 * 获取缓存的预创建订单结果
 * @returns {Object|null} 缓存结果或null
 */
export function getCachedPreOrder() {
  try {
    const cached = localStorage.getItem('preOrderCache')
    if (!cached) return null
    
    const data = JSON.parse(cached)
    
    // 检查是否过期
    if (data.expiresAt && Date.now() > data.expiresAt) {
      localStorage.removeItem('preOrderCache')
      return null
    }
    
    return data
  } catch (error) {
    console.warn('读取缓存订单失败:', error)
    return null
  }
}

/**
 * 清除缓存的预创建订单
 */
export function clearPreOrderCache() {
  try {
    localStorage.removeItem('preOrderCache')
    sessionStorage.removeItem('latestPreOrder')
  } catch (error) {
    console.warn('清除缓存失败:', error)
  }
}

/**
 * 正式创建订单（调用支付）
 * @param {Object} orderData - 订单数据
 * @returns {Promise} 支付表单或支付信息
 */
export async function createRealOrder(orderData) {
  try {
    const response = await http.post(
      '/aics/order/create',
      orderData,
      {
        headers: {
          'Content-Type': 'application/json'
        }
      }
    )
    
    if (!response.data || response.code !== 200) {
      throw new Error(response.message || '创建订单失败')
    }
    
    // 清除预创建缓存
    clearPreOrderCache()
    
    return response.data
    
  } catch (error) {
    console.error('创建正式订单失败:', error)
    
    // 如果是预创建订单过期，重新预创建
    if (error.message.includes('订单已过期') || error.message.includes('缓存不存在')) {
      throw new Error('订单信息已过期，请重新选择商品')
    }
    
    throw error
  }
}

/**
 * 确认订单（二阶段提交的确认阶段）
 * @param {String} tempOrderNo - 临时订单号
 * @param {String} paymentMethod - 支付方式
 * @returns {Promise} 支付表单
 */
export async function confirmOrder(tempOrderNo, paymentMethod = 'alipay') {
  try {
    const response = await http.post(
      '/aics/order/confirm',
      {
        tempOrderNo,
        paymentMethod
      }
    )
    
    return response.data
    
  } catch (error) {
    console.error('确认订单失败:', error)
    throw error
  }
}

/**
 * 查询订单状态
 * @param {String} orderNo - 订单号
 * @returns {Promise} 订单状态
 */
export async function getOrderStatus(orderNo) {
  try {
    const response = await http.get(
      `/aics/order/status/${orderNo}`
    )
    
    return response.data
    
  } catch (error) {
    console.error('查询订单状态失败:', error)
    throw error
  }
}

/**
 * 取消预创建订单
 * @param {String} tempOrderNo - 临时订单号
 */
export async function cancelPreOrder(tempOrderNo) {
  try {
    const response = await http.post(
      `/aics/order/cancel-preorder/${tempOrderNo}`
    );
    clearPreOrderCache();
    return response.data;
  } catch (error) {
    console.warn('取消预创建订单失败:', error);
    throw error;
  }
}

export async function removeOrder(id) {
  console.log("removeOrder",id);
  try {
    const response = await http.delete(
      `aics/order/${id}`
    );
    return response;
  } catch (error) {
    console.warn('删除订单失败:', error);
    throw error;
  }  
}

/**
 * 获取最新订单信息
 */
export async function getLatestOrderInfo() {
  try {
    const response = await http.get('/aics/order/latest')
    return response.data
  } catch (error) {
    console.error('获取最新订单失败:', error)
    return null
  }
}



/**
 * 验证订单结果，支持多种字段命名格式
 */
function validateOrderResult(result) {
    if (!result) return false;
    
    // 检查是否有金额字段（支持多种命名）
    const hasAmount = 
        (result.payable_amount !== undefined && result.payable_amount !== null) ||
        (result.payableAmount !== undefined && result.payableAmount !== null) ||
        (result.final_amount !== undefined && result.final_amount !== null) ||
        (result.finalAmount !== undefined && result.finalAmount !== null);
    
    // 检查是否有订单号字段（支持多种命名）
    const hasOrderNo = 
        (result.temp_order_no !== undefined && result.temp_order_no !== null) ||
        (result.tempOrderNo !== undefined && result.tempOrderNo !== null);
    
    return hasAmount && hasOrderNo;
}

/**
 * 标准化订单结果，统一字段命名

function normalizeOrderResult(result) {
    if (!result) return null;
    
    return {
        // 统一使用下划线命名
        temp_order_no: result.temp_order_no || result.tempOrderNo,
        original_total: result.original_total || result.originalTotal,
        discount_amount: result.discount_amount || result.discountAmount,
        payable_amount: result.payable_amount || result.payableAmount || 
                        result.final_amount || result.finalAmount,
        final_amount: result.final_amount || result.finalAmount || 
                     result.payable_amount || result.payableAmount,
        item_details: result.item_details || result.itemDetails,
        applied_promotions: result.applied_promotions || result.appliedPromotions,
        calculation_time: result.calculation_time || result.calculationTime,
        calculation_type: result.calculation_type || result.calculationType,
        // 保留原始数据
        _raw: result
    };
}
     */


// 重新购买订单aics/order/
export function renewOrder(orderNo) {
  return http.post(
    `/aics/order/renew/${orderNo}`    
  );
}